import React from 'react';
import { bindPopover, usePopupState } from 'material-ui-popup-state/hooks';

import { deletePaginationParams } from '@occc-app/hooks/usePaginationParams';
import { useQueryParam } from '@occc-app/hooks/useQueryParam';

import { IdentifierFormValues } from './types';

const IDENTIFIER_FILTER_PARAM = 'identifier';
const IS_TAR_ELIGIBLE_FILTER_PARAM = 'isTarEligible';

export const useProductGroupFilter = () => {
  const productGroupPopupState = usePopupState({ variant: 'popover', popupId: 'filters' });
  const productGroupPopoverProps = React.useMemo(() => {
    return {
      ...bindPopover({
        ...productGroupPopupState,
      }),
    };
  }, [productGroupPopupState]);

  const [identifierFilter, setIdentifierFilter] = useQueryParam<IdentifierFormValues>(
    (searchParams) => {
      const identifier = searchParams.get(IDENTIFIER_FILTER_PARAM) || 'all';
      return identifier as IdentifierFormValues;
    },
    (value, searchParams) => {
      if (value && value !== 'all') {
        searchParams.set(IDENTIFIER_FILTER_PARAM, value);
      } else {
        searchParams.delete(IDENTIFIER_FILTER_PARAM);
      }

      deletePaginationParams(searchParams);
    },
  );

  const [tarEligibleFilter, setTarEligibleFilter] = useQueryParam<boolean>(
    (searchParams) => {
      const tarEligibleSearchParam = searchParams.get(IS_TAR_ELIGIBLE_FILTER_PARAM);
      const isTarEligible =
        tarEligibleSearchParam && tarEligibleSearchParam === 'true' ? true : false;
      return isTarEligible;
    },
    (value, searchParams) => {
      if (value) {
        searchParams.set(IS_TAR_ELIGIBLE_FILTER_PARAM, 'true');
      } else {
        searchParams.delete(IS_TAR_ELIGIBLE_FILTER_PARAM);
      }

      deletePaginationParams(searchParams);
    },
  );

  return {
    identifierFilter,
    setIdentifierFilter,
    tarEligibleFilter,
    setTarEligibleFilter,
    productGroupPopoverProps,
    productGroupPopupState,
  };
};
